import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React, { useState } from 'react'
import { useTranslate } from 'react-admin'
import { ResourceName } from '../../core/ResourceName'
import { ConfirmDialog } from '../common/ConfirmDialog'
import Button from '../common/customized-mui-components/Button'
import DraggableComponent from '../common/DraggableComponent'

const useStyles = makeStyles({
  bulkStateActions: {
    height: '16px',
    background: 'rgba(0,0,0,0.2)',
    minWidth: '300px',
    userSelect: 'none',
  },
  bulkProgressTitle: {
    paddingLeft: '10px',
    width: '100%',
  },
  bulkProgressCloseButton: {
    margin: 0,
  },
  actionsButton: {
    margin: '2%',
    width: '96%',
  },
  iconContainer: {
    width: 34,
    height: 34,
  },
  icon: {
    position: 'relative',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'relative',
    left: -24,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
  formToolbar: {
    backgroundColor: 'inherit',
    padding: 0,
    margin: 0,
  },
  dialogContent: {
    padding: '8px',
  },
})

export const PrintBarcodeTicketDialog = ({
  open,
  close,
  note,
  setNote,
  handleOpen,
}: {
  open: boolean
  close: () => void
  note?: string
  setNote: (value: string) => void
  handleOpen: () => void
}) => {
  const classes = useStyles()
  const [ticketPrinting, setTicketPrinting] = useState(false)
  const translate = useTranslate()

  const handleClose = () => {
    setTicketPrinting(false)
    close()
  }

  const handlePrintTicket = () => {
    handleOpen()
    handleClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick
      disableEscapeKeyDown
      PaperComponent={DraggableComponent}
      aria-labelledby="draggable-dialog-title"
      onClick={(e) => e.stopPropagation()}
    >
      <ConfirmDialog
        open={ticketPrinting}
        cancel={() => setTicketPrinting(false)}
        confirm={handlePrintTicket}
        source="printBarcodeTicket"
        action="set"
        resource={ResourceName.TICKETS}
      />
      <DialogActions
        className={classes.bulkStateActions}
        style={{ cursor: 'move' }}
      >
        <Typography
          className={classes.bulkProgressTitle}
          id="draggable-dialog-title"
        >
          {translate(
            'resources.tickets.dialogs.PrintBarcodeTicketDialog.title',
          )}
        </Typography>
        <IconButton
          size="small"
          className={classes.bulkProgressCloseButton}
          onClick={handleClose}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogActions>
      <DialogContent>
        <TextField
          variant="outlined"
          value={note}
          onChange={(e) => setNote(e?.target?.value)}
          fullWidth
          label={translate(
            'resources.terminals.fields.print-parking-ticket-note',
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => setTicketPrinting(true)}
          label={translate('ra.action.save')}
          useSmallVersionBreakpoint={false}
          className={classes.actionsButton}
          disabled={!note}
        />
        <Button
          variant="contained"
          onClick={handleClose}
          label={translate('const.cancel')}
          useSmallVersionBreakpoint={false}
          className={classes.actionsButton}
        />
      </DialogActions>
    </Dialog>
  )
}
